<template>
  <v-card>
    <v-card-title class="d-flex justify-center">{{ mode }}</v-card-title>
    <div class="px-4">
      <v-form
        @submit.prevent="initializeMassiveResponse"
        ref="form"
        v-model="valid"
      >
        <v-alert
          dense
          v-if="error"
          color="red"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mx-1"
        >
          {{ alertValidate }}
        </v-alert>
        <v-text-field
          dense
          type="number"
          :label="$tc('CurrentAccounts.quantityLabel')"
          outlined
          v-model="cantidad"
          :rules="[rules.required]"
        />
        <div v-if="!error" class="d-flex justify-space-between">
          <v-btn class="bt-exit mb-4" @click="cancel">{{
            $tc("editRegistrations.cancel")
          }}</v-btn>
          <v-btn type="submit" class="bt-acept">
            {{ $tc("editRegistrations.acept") }}</v-btn
          >
        </div>
        <div v-else class="d-flex justify-center pb-4">
          <v-btn color="primary" @click="cancel">{{
            $tc("newController.close")
          }}</v-btn>
        </div>
      </v-form>
    </div>
  </v-card>
</template>

<script>
import currentAccounts from "@/store/currentAccounts/currentAccounts";

export default {
  props: {
    mode: String,
    accountId: Number,
  },
  data() {
    return {
      valid: true,
      error: false,
      alertValidate: "",
      cantidad: null,
      rules: {
        required: (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      },
    };
  },
  methods: {
    async initializeMassiveResponse() {
      try {
        const item = {
          cuentaId: this.accountId,
          cantidad: this.cantidad,
        };
        currentAccounts.commit("setNew", item);
        const response = await currentAccounts.dispatch("initializeMassive");

        if (response.data && response.data.length) {
          const employeeIds = response.data
            .map((item) => item.empNombre || "")
            .join(", ");
          this.alertValidate = `${this.$tc(
            "CurrentAccounts.massiveSuccess"
          )}: ${employeeIds}`;
          this.error = true;
        } else {
          this.cancel();
        }
      } catch (error) {
        this.error = true;
        this.alertValidate = error.response.data.error.message;
        console.error(error);
      }
    },

    cancel() {
      this.cantidad = null;
      this.$refs.form.resetValidation();
      this.$emit("cancel", false);
      if (this.error === true) {
        this.error = !this.error;
      }
    },

    alert(message, color, persistent) {
      this.error = true;
      this.alertValidate = message;
      if (!persistent) {
        setTimeout(() => {
          this.error = false;
          this.alertValidate = "";
        }, 2500);
      }
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
